import { request } from '@umijs/max';

const getCurrentPlan = async () => {
  const response = await request('/user/current-plan', {
    method: 'GET',
  });
  return response;
};

export default {
  namespace: 'subscription',
  state: {
    people_credits_remaining: 0,
    product_credits_remaining: 0,
    next_renewal_date: '',
    subscription: null,
    people_credit_costs: {
      email: 2,
      phone: 10,
    },
  },

  effects: {
    *getCurrentPlan(_: any, { call, put }: any) {
      try {
        const response: Promise<any> = yield call(getCurrentPlan);
        yield put({
          type: 'updateSubscriptionState',
          payload: response,
        });

        console.log('response from getCurrentPlan: ', response);
        return response;
      } catch (error) {
        console.error('Failed to fetch current plan:', error);
        throw error;
      }
    },
  },

  reducers: {
    reset() {
      return { people_credits_remaining: 0, product_credits_remaining: 0, next_renewal_date: '', subscription: null, people_credit_costs: { email: 2, phone: 10 } };
    },
    updateSubscriptionState(state: any, { payload }: any) {
      return {
        ...state,
        ...payload,
      };
    },
    deductCredits(state: any, { payload }: any) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
